import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//Component Imports
import { HomeIndexComponent } from './home-index/home-index.component';
import { BulletinComponent } from './bulletin/bulletin.component';
import { NotificationPageComponent } from '../../core/components/notification-page/notification-page.component';

const routes: Routes = [
  {
    path: '',
    component: HomeIndexComponent
  },
  {
    path: 'index',
    redirectTo: ''
  },
  {
    path: 'bulletin/:bulletinID',
    component: BulletinComponent
  },
  {
    path: "notifications",
    component: NotificationPageComponent
  }
];


@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
